import Evaporate from 'evaporate';
import SparkMD5 from 'spark-md5';
import variable from '@/config/variables';
import webcall from '@/libs/webcall';

/**
 * TODO: Need to implement uploader inside a web-worker. Currently slowing down the main thread (i.e. UI) when uploading is in progress.
 * Make the default Evaporate configuration for uploading the main video file.
 * @returns a configuration file for Evaporate.create()
 */
const makeEvaporateConfig = () => {
  const config = {
    awsSignatureVersion: 2,
    signerUrl: variable.AWS.SIGNER_URL,
    signHeaders: webcall.getHeader(),
    aws_key: variable.AWS.KEY,
    bucket: variable.AWS.BUCKET,

    encodeFilename: false,
    logging: false,
    computeContentMd5: true,
    cryptoMd5Method: data => btoa(SparkMD5.ArrayBuffer.hash(data, true)),
    onlyRetryForSameFileName: true,
    s3Acceleration: false,
  };
  // NOTE: If s3Acceleration is disabled execute the 2 lines below.
  if (!config.s3Acceleration) {
    config.aws_url = variable.AWS.UPLOAD_ENDPOINT;
    config.cloudfront = true;
  }
  return config;
};

/**
 * Generate aws file key using a fileMeta object.
 * @param {*} fileMeta
 */
const makeAwsFileKey = (fileMeta) => {
  if (!fileMeta.path || !fileMeta.name) throw new Error('fileMeta.path and/or fileMeta.name is invalid');
  return fileMeta.path + fileMeta.name;
};

/**
 * Uploader - abstract the upload process.
 * Uploader currently uses evaporate to handle video uploading.
 */
export default class Uploader {
  constructor() {
    this.config = makeEvaporateConfig();
    this.evaporate = Evaporate.create(this.config);
  }

  /**
   * Upload a file to AWS
   * @param {object} fileMeta
   * @param {function} progressTickCallback
   * @returns the url to AWS upon the completion of uploading
   */
  upload(fileMeta, progressTickCallback) {
    // Begin uploading process
    return this.evaporate
      .then(evaporate =>
        evaporate.add({
          'name': makeAwsFileKey(fileMeta),
          'file': fileMeta.file,
          'x-amz-acl': 'public-read',
          'progress': progressTickCallback,
        })
      )
      // awsS3ObjectKey format: bucketName/name
      .then((awsS3ObjectKey) => {
        const filePathUrl = `https://viddsee.s3-ap-southeast-1.amazonaws.com/${awsS3ObjectKey}`;
        return filePathUrl;
      });
  }

  /**
   * Cancel an on-going AWS upload
   * @param {object} fileMeta
   * @returns a promise that resolves when the upload is completely canceled or rejects if the upload could not be canceled without errors.
   */
  cancel(fileMeta) {
    // Begin uploading process
    const awsS3ObjectKey = `${variable.AWS.BUCKET}/${makeAwsFileKey(fileMeta)}`;
    return this.evaporate
      .then(evaporate =>
        evaporate.cancel([awsS3ObjectKey])
      );
  }
}




// WEBPACK FOOTER //
// ./src/libs/uploader.js